module.exports = __webpack_public_path__ + "4ffca7814c88417984788425c1a508cc.svg";